import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from './app-config.service';
import { ErrorHandlerService } from './error-handler.service';
import { PreferenceControlModule } from '../models/preference-control-modules.model';

@Injectable({
  providedIn: 'root'
})
export class PreferenceControlModuleService {

  constructor(private http: HttpClient, private errorHandler: ErrorHandlerService, private appConfigService: AppConfigService) { }

  public getPreferenceControlModules(): Observable<PreferenceControlModule[]> {
    return this.http.get<PreferenceControlModule[]>(`${this.appConfigService.getConfig().webApi}/api2/PreferenceControlModules`)
      .pipe(catchError(this.errorHandler.handleError<PreferenceControlModule[]>(`get PreferenceControlModule`)));
  }

  public updatePreferenceControlModule(controlPreference: PreferenceControlModule): Observable<PreferenceControlModule> {
	return this.http.post<PreferenceControlModule>(`${this.appConfigService.getConfig().webApi}/api2/PreferenceControlModules`, controlPreference)
      .pipe(catchError(this.errorHandler.handleError<PreferenceControlModule>(`updateControlPreference with caseId=${controlPreference.caseId} & Id=${controlPreference.moduleId}`)));
  }
}
